import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { DevicesCountByHourItem } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  params?: {
    dateFrom: string;
    dateTo?: string;
    sensorType?: 'verizon' | 'lorawan';
  };
  options?: Omit<
    UseQueryOptions<DevicesCountByHourItem[], Error>,
    'queryKey' | 'queryFn'
  >;
}

export const useDevicesCountByHourRequest = ({
  params = { dateFrom: new Date().toISOString() },
  options,
}: RequestParams = {}) => {
  const api = useApiInstance()

  return useQuery<DevicesCountByHourItem[], Error>(
    [Entities.Diagnostics, 'devices-count-by-hour', JSON.stringify(params)],
    async () => {
      const { dateFrom, sensorType, dateTo } = params
      const { data } = await api.v1AdminHardwareDevicesCountByHourGet(dateFrom, sensorType, dateTo)
      return data as DevicesCountByHourItem[]
    },
    options,
  )
}
